// Field — shared definition-list cell (a <dt>/<dd> pair) used across the
// channel + campaign detail views. Phase 4c: promoted from
// components/channel/Field to this neutral ui/ home and de-duplicated with the
// byte-identical local copies that had been re-declared in CampaignDetail and
// CampaignChannelSection.
export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="text-sm">{children}</dd>
    </div>
  );
}
